import { useState } from "react";
import { guideItems } from "@/mocks/films";

export default function WatchGuide() {
  const [openId, setOpenId] = useState<string | null>(guideItems[0]?.id ?? null);

  return (
    <section id="guide" className="w-full bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] gap-8 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label text-accent-800 bg-accent-100 px-3 py-1.5 rounded-full">
              <i className="ri-compass-3-line" aria-hidden="true"></i>
              观影指南
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug">
              用四个问题，找到适合自己的看法
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              老片与新片、武侠与动作，观看方式其实不太一样。下面这些问题按常见困惑整理，点开即可看到具体建议。
            </p>

            <ul className="mt-7 space-y-3">
              {[
                { icon: "ri-timer-flash-line", text: "按节奏选入口，而不是按年代" },
                { icon: "ri-eye-line", text: "老片重看调度与光影，胜过只看情节" },
                { icon: "ri-repeat-2-line", text: "同题材对照着看，差别会更清楚" },
              ].map((row) => (
                <li key={row.text} className="flex items-center gap-3 text-sm text-foreground-700">
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${row.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  {row.text}
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-3">
            {guideItems.map((item) => {
              const open = openId === item.id;
              return (
                <div key={item.id} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : item.id)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.q}</span>
                    <span
                      className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                    </span>
                  </button>
                  {open && (
                    <div className="px-4 md:px-5 pb-4 -mt-1">
                      <p className="text-sm md:text-[15px] text-foreground-600 leading-relaxed border-t border-background-200 pt-3">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}